<template>
    <div class="login-panel-content">
        <Form v-if="loginView" @submit="login">
            <div class="flex flex-column align-items-end">
                <div v-if="loginError" class="p-mb-5">{{ $t('message.login.loginError') }}</div>
                <CustomInputText :name="`${name}-login`" v-model="loginForm.login" :label="$t('message.login.login')"
                                 rules="required" class="w-10" noPlaceholder/>
                <CustomTextButton label="Forgot password?" @click="loginView = false" />
                <CustomPassword :name="`${name}-password`" v-model="loginForm.password"
                                :label="$t('message.login.password')" rules="required"
                                class="w-10"/>
                <div class="login-error" v-if="isBlocked">
                    {{ $t('message.login.failedLogin') }}
                </div>
                <div class="login-error" v-if="badCredentials">
                    {{ $t('message.login.incorrect') }}
                </div>
                <div class="flex align-self-center gap-4">
                    <CustomButton :label="$t('message.login.action.login')" type="submit"
                                  class="align-self-center mt-3 login-button" />
                </div>
            </div>
        </Form>
        <Form v-else @submit="recoverPassword">
            <div class="flex flex-column align-items-center">
                <p v-if="success" class="text-center">
                    {{ $t('message.login.successRemindPasswordMail') }}
                </p>
                <p v-else-if="alreadySent" class="text-center">
                    {{ $t('message.login.alreadySent') }}
                </p>
                <p v-else class="text-center">
                    {{ $t('message.login.remindPasswordMsg') }}
                </p>
                <CustomInputText name="email" :label="$t('message.login.email')" class="w-10" v-model="email"
                                 noPlaceholder />
                <div class="flex align-self-center gap-4 mt-6">
                    <CustomButton :label="$t('message.login.action.backToLogin')" @click="loginView = true" />
                    <CustomButton :label="$t('message.login.action.sendLink')" type="submit" />
                </div>
            </div>
        </Form>
    </div>
</template>

<script>
    import {Form} from "vee-validate";
    import {
        login as loginRequest,
        remindPassword,
    } from "@/swagger/vue-api-client";
    import CustomPassword from "../components/form/CustomPassword";
    import CustomInputText from "../components/form/CustomInputText";
    import CustomButton from "@/components/form/CustomButton.vue";
    import CustomTextButton from "@/components/form/CustomTextButton.vue";
    import { ThemeSettingsHelper } from "@/mixins/themeSettings";

    export default {
        name: "LoginForm",

        components: {
            CustomInputText,
            CustomPassword,
            Form,
            CustomButton,
            CustomTextButton,
        },

        props: {
            name: "",
            horseBreed: "",
        },

        data() {
            return {
                loginError: false,
                loginForm: {
                    login: "",
                    password: "",
                },
                isBlocked: false,
                badCredentials: false,
                horseType: null,
                loginView: true,
                email: "",
                success: false,
                alreadySent: false,
                lastSentEmail: "",
            };
        },

        methods: {
            isDisabled(errors) {
                return !(errors && Object.keys(errors).length === 0
                    && Object.getPrototypeOf(errors) === Object.prototype);
            },
            login() {
                loginRequest({
                        body: this.loginForm,
                        $config: {
                            headers: {
                                "Content-Type": "application/json",
                                "X-Frontend-Breed-Source": this.horseBreed,
                            },
                        },
                    })
                    .then((response) => {
                        // Store access token only (refresh token is in HttpOnly cookie)
                        const token = response.data.token || response.data.accessToken;
                        localStorage.setItem("token", token);
                        localStorage.setItem("role", response.data.role);
                        localStorage.setItem("roleName", response.data.roleName);
                        localStorage.setItem("fullName", response.data.fullName);
                        localStorage.setItem("horseBreed", this.horseBreed);
                        ThemeSettingsHelper.checkLocalStorageForHorseBreed();

                        if (response.data.role === "LAB_USER" && (!this.$route.query.next || this.$route.query.next === "/" || this.$route.query.next === "/home")) {
                            this.$router.push({path: "/pending/list"});
                        } else if (this.$route.query.next) {
                            this.$router.push(this.$route.query.next);
                        } else {
                            this.$router.push({path: "/"});
                        }
                    })
                    .catch((error) => {
                        console.error(error.status);
                        switch (error.status) {
                            case 429:
                                this.isBlocked = true;
                                this.badCredentials = false;
                                break;
                            case 401:
                                this.badCredentials = true;
                                this.isBlocked = false;
                                break;
                            default:
                        }
                    });
            },
            recoverPassword() {
                if (this.email !== this.lastSentEmail) {
                    remindPassword({
                            body: this.email,
                            $config: {
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Frontend-Breed-Source": this.horseBreed,
                                },
                        },
})
                        .then(() => {
                            this.alreadySent = false;
                            this.success = true;
                            this.lastSentEmail = this.email;
                            this.loginView = true;
                            this.$toast.add({
                                severity: "success",
                                summary: this.$t("message.other.success"),
                                detail: this.$t("message.login.successRemindPasswordMail"),
                                life: 3000,
                            });
                        });
                } else {
                    this.success = false;
                    this.alreadySent = true;
                }
            },
            successRemindPassword() {
                this.$toast.add({
                    severity: "success",
                    summary: this.$t("message.other.success"),
                    detail: this.$t("message.login.successRemindPasswordMail"),
                    life: 3000,
                });
            },
        },

        watch: {
            loginView(value) {
                if (value && this.success) {
                    this.success = false;
                }
            },
            email(value) {
                if ((value == null || value === "") && this.success) {
                    this.success = false;
                }
            },
        },
    };
</script>

<style lang="scss">
</style>
